import { render, staticRenderFns } from "./tabs-router.vue?vue&type=template&id=c39f6750&scoped=true&"
import script from "./tabs-router.vue?vue&type=script&lang=js&"
export * from "./tabs-router.vue?vue&type=script&lang=js&"
import style0 from "./tabs-router.vue?vue&type=style&index=0&id=c39f6750&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39f6750",
  null
  
)

export default component.exports